import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  constructor() { }

  log(object) {
    console.log(object);
  }

  error(object) {
    console.error(object);
  }
}
